module.exports = __webpack_public_path__ + "assets/img/ecg-detail-back-banner4.c5c094b0.png";